import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../../../ui/card';
import { CreditSubmission } from '../../../../api/creditSubmissionApi';
import { formatCurrency } from './utils';

interface DetailSection4Props {
  submission: CreditSubmission;
}

export default function DetailSection4({ submission }: DetailSection4Props) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>4. Riwayat Bank</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid md:grid-cols-2 gap-4">
          <div>
            <label className="text-sm text-gray-600">Hubungan dengan Bank</label>
            <p className="font-medium mt-1">{submission.bank_relationship || '-'}</p>
          </div>
          <div>
            <label className="text-sm text-gray-600">Fasilitas Terakhir</label>
            <p className="font-medium mt-1">{submission.last_facility || '-'}</p>
          </div>
          <div>
            <label className="text-sm text-gray-600">Kualitas Kredit Terakhir</label>
            <p className="font-medium mt-1">{submission.last_credit_quality || '-'}</p>
          </div>
          <div>
            <label className="text-sm text-gray-600">Tunggakan Terakhir</label>
            <p className="font-medium mt-1">{formatCurrency(submission.last_arrears)}</p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
